export default {
    connections: state => {
        return state.connections;
    }
}
